import moment from 'moment'
import 'moment/dist/locale/pt-br'

export function setupMoment(lang) {
    moment.locale(lang === 'pt' ? 'pt-br' : lang)
}
